import {MenuItemType} from '@models/sidebar/menu-item-type';

export class BaseMenuItem {
  id: string | null = null;
  name: string = '';
  organizationId?: number | null = null;
  machineId: string | null = null;
  machineGroupId?: number | null = null;
  pageId?: string | null = null;
  index: number = -1;
  parent: any;
  parentId?: string | null = null;
  type: MenuItemType = MenuItemType.NONE;
  machineCategory?: string | null = null;
  url: string | undefined = undefined;
  disabled?: boolean = false;

  get parentIsMachineGroup(): boolean {
    return !!this.machineGroupId;
  }

  get isMachine(): boolean {
    return this.type === MenuItemType.MACHINE;
  }

  get isMachineGroup(): boolean {
    return this.type === MenuItemType.MACHINE_GROUP;
  }
}